var paymentSelector = (function() {
	var $paymentSelector, $selectedIndex, $selectedType, $selectMethodButton, $selectedMethodContainer, $methodSelectList, $paymentTermsContainer;
	var methodSelectListOpen = false;
	var paymentMethodTypeTermsFormat = "terms-confirm-static-";

	var init = function () {
		$paymentSelector = $(".payment-selector");
		$selectedMethodContainer = $(".selected-method-container");

		if (!$paymentSelector.length && !$selectedMethodContainer.length) {
			return;
		}

		$selectedIndex = $("[data-payment-method-selector-role=hidden-field]");
		$selectedType = $("[data-payment-method-type-selector-role=hidden-field]");
		$selectMethodButton = $("[data-action=selected-method]");
		$paymentTermsContainer = $(".terms-confirm-container");

		// Setup the payment selector if present
		if ($selectMethodButton.length) {
			$methodSelectList = $paymentSelector.find(".selector-box");
			// Setup showing of payment methods
			$selectMethodButton.on("click", togglePaymentMethods);
			// Setup selection of paymnet methods
			$methodSelectList.on("click touch", ".selector-item:not(.unavailable)", selectPaymentMethod);
		}

		// Setup initial visiblity on payment terms
		togglePaymentMethodTypeTermsToDisplay();
		if ($paymentTermsContainer.length) { // if page has a terms container then check what terms (if any) the loaded payment method has to display
			var $paymentTermsSource = $selectedMethodContainer.find("[data-pp-confirm-terms]");
			togglePaymentMethodTermsToConfirm($paymentTermsSource);
		}

	};

	var togglePaymentMethods = function ( ) { //this has e as an arugment but not used
		if (!methodSelectListOpen) {
			$methodSelectList.addClass("visible");
		} else {
			$methodSelectList.removeClass("visible");
		}
		methodSelectListOpen = !methodSelectListOpen;
	};

	var selectPaymentMethod = function ( ) {//this has e as an arugment but not used
		var $cardReference = $(this).find(".card-reference");
		var selectedPaymentMethodIndex = $cardReference.attr("data-payment-method-index");
		var selectedPaymentMethodType = $cardReference.attr("data-payment-method-type");

		updateSelectedPaymentInfo(selectedPaymentMethodIndex, selectedPaymentMethodType);
		showSelectedCardReference($cardReference);

		togglePaymentMethods();

		togglePaymentMethodTypeTermsToDisplay();
		if ($paymentTermsContainer.length) { // if page has a terms container then check what terms (if any) this payment method has to display
			var $paymentTermsSource = $(this).find("[data-pp-confirm-terms]");
			togglePaymentMethodTermsToConfirm($paymentTermsSource);
		}
	};

	var updateSelectedPaymentInfo = function (index, type) {
		$selectedIndex.val(index);
		$selectedType.val(type);
	};

	var showSelectedCardReference = function (cardReference) {
		$selectedMethodContainer
			.html(cardReference.parent().html())
			.show();
	};

	var togglePaymentMethodTermsToConfirm = function (paymentTermsSource) {
		if (!paymentTermsSource.length) { // the selected payment method doesn't have terms so hide the payment method terms confirmation container
			$paymentTermsContainer.hide();
			return;
		}

		// show the payment method terms text that the user needs to confirm
		var $termsToDisplay = $paymentTermsContainer.find("[data-pp-terms-confirm-text]");
		$termsToDisplay.html(paymentTermsSource.html());
		$paymentTermsContainer.show();
	};

	var togglePaymentMethodTypeTermsToDisplay = function() {
		// hide all payment method type terms text
		$("[class^='" + paymentMethodTypeTermsFormat + "']").hide();
		// show the active payment method type terms text
		$("." + paymentMethodTypeTermsFormat + $selectedType.val().toLowerCase()).show();
	};

	return { init: init };
}());

$(function() {
	paymentSelector.init();
});
